import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'siu-button-expandable',
  templateUrl: './button-expandable.component.html',
  styleUrls: ['./button-expandable.component.scss']
})
export class ButtonExpandableComponent implements OnInit {
  @Input() opened: boolean = false;
  @Output() open: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean = false;

  constructor() {}

  ngOnInit() {}

  handleToogle = () => {
    if (this.opened) {
      this.close.emit();
    } else {
      this.open.emit();
    }
  };
}
